import Axios from "./Axios";
import ENDPOINTS from "./endpoints";

export interface ICountry {
  code: string;
  name: string;
  currencyCode: string;
  currencySymbol: string;
  flagEmoji: string;
  dialCode: string;
  language: string;
}

export const DEFAULT_COUNTRIES: ICountry[] = [
  {
    code: "PK",
    name: "Pakistan",
    currencyCode: "PKR",
    currencySymbol: "Rs.",
    flagEmoji: "🇵🇰",
    dialCode: "+92",
    language: "en",
  },
  {
    code: "US",
    name: "United States",
    currencyCode: "USD",
    currencySymbol: "$",
    flagEmoji: "🇺🇸",
    dialCode: "+1",
    language: "en",
  },
];

const getCountries = async (): Promise<ICountry[]> => {
  const res = await Axios.get<any>(ENDPOINTS.country.all);
  const body = res?.data ?? {};
  if (!body || typeof body !== "object" || Array.isArray(body)) return DEFAULT_COUNTRIES;
  const countries = Object.entries(body).map(([key, value]: [string, any]) => ({
    code: key.toUpperCase(),
    name: value?.countryName || key.toUpperCase(),
    currencyCode: value?.currency || "",
    currencySymbol: value?.symbol || "",
    flagEmoji: value?.flagEmoji || "",
    dialCode: value?.dialCode || "",
    language: value?.language || "en",
  }));
  return countries.length ? countries : DEFAULT_COUNTRIES;
};

const CountryService = { getCountries };

export default CountryService;
